import { useEffect, useState } from 'react';
import { formatArrivalDate } from '@/components/customercenter-ui/components/utils/formatUtils';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/customercenter-ui/ui/card';
import { maskPhoneNumber, maskPostalCode } from '@/components/customercenter-ui/utils/formatUtils';
import { mapLocaleToMeaningfulFormat } from '@/helpers/utils/i18n';

const OrderShippingAddress = ({ order }: any) => {
  const [shippingInfo, setShippingInfo] = useState<any>({});

  useEffect(() => {
    const storedShippingInfoStr = localStorage.getItem('cartItemsDate');
    let storedShippingInfo;
    try {
      storedShippingInfo = storedShippingInfoStr ? JSON.parse(storedShippingInfoStr) : null;
      setShippingInfo(storedShippingInfo);
    } catch (error) {
      console.error('Error parsing storedShippingInfo:', error);
    }
  }, []);

  const cartDeliveryDate = formatArrivalDate(shippingInfo?.date, mapLocaleToMeaningfulFormat());
  const deliveryName = shippingInfo?.name;

  return (
    <Card className="w-full rounded-none border-t border-foggyGray p-2 md:mb-0 md:mt-4 md:rounded-md md:border md:shadow-lg">
      <CardHeader className="py-5 pl-6">
        <CardTitle className="flex flex-wrap">
          <p className="mr-auto text-22 font-bold">{mapLocaleToMeaningfulFormat().shipping}</p>
        </CardTitle>
      </CardHeader>
      <CardContent className="pb-0 md:pb-6">
        <section className={`grid gap-4 lg:grid-cols-2`}>
          <section>
            <p className="text-lg font-bold">{mapLocaleToMeaningfulFormat().shippingAddress}</p>
            <p className="gbmask overflow-hidden text-ellipsis pt-2 text-base font-normal lg:pr-3">
              {order?.shippingAddress?.firstName} {order?.shippingAddress?.lastName} <br />
              {order?.shippingAddress?.streetName} <br />
              {order?.shippingAddress?.additionalAddressInfo ? (
                <>
                  {order?.shippingAddress?.additionalAddressInfo}
                  <br />
                </>
              ) : (
                ''
              )}
              {order?.shippingAddress?.city}, {order?.shippingAddress?.state}{' '}
              {maskPostalCode(order?.shippingAddress?.postalCode ?? '')}
            </p>
            <p className="gbmask pt-2.5">{maskPhoneNumber(order?.shippingAddress?.phone)}</p>
          </section>
          {order?.giftNotes ? (
            <section className="overflow-hidden pb-4 lg:pl-4 lg:pt-0">
              <p className="text-lg font-bold">{mapLocaleToMeaningfulFormat().giftMessagePlaceholder}</p>
              <p className="gbmask mt-2.5 break-words">{order?.giftNotes}</p>
            </section>
          ) : (
            <></>
          )}
          <section className="pt-8 md:pt-0">
            <ul>
              <li className="mb-6 flex flex-col">
                <p className="text-lg font-bold">{mapLocaleToMeaningfulFormat().shippingMethods}</p>
                <p className="mt-2.5">
                  {mapLocaleToMeaningfulFormat().arrivesBy} <strong>{cartDeliveryDate}</strong>
                </p>
                <p>{deliveryName}</p>
              </li>
              {order?.isSignatureRequired && (
                <li className="mb-6 flex flex-col">
                  <p className="font-bold">Signature Required</p>
                </li>
              )}
            </ul>
          </section>
        </section>
      </CardContent>
    </Card>
  );
};

export default OrderShippingAddress;
